import { AlgoIcon, EthIcon } from 'src/common/assets'
import { ChainName } from './name'

export const ASSET_ICON = {
  [ChainName.ETHEREUM]: EthIcon,
  [ChainName.ALGORAND]: AlgoIcon
}
